module.exports = __webpack_public_path__ + "media/1_3-56.9ed57dcb.mp3";